module.exports = __webpack_public_path__ + "88ce3a8e3d928fb9f57caf35f04c92a0.png";